import { useSessionStorage } from 'react-use';

const SESSION_STORAGE_KEY = 'vfi_search_q';

export const useSearchString = () => {
	const [searchString, setSearchString] = useSessionStorage<string>(SESSION_STORAGE_KEY, null);

	return { searchString, setSearchString };
};
